import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { BaseApiResponse } from 'app/core/models/api/api.model';
import { UlcerWoundType } from 'app/core/models/ulcer-wound-type/ulcer-wound-type.model';
import { environment } from '../../../../environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UlcerWoundTypeService {
  constructor(private apiService: ApiService) {}

  async getListUlcerWoundType(): Promise<BaseApiResponse<UlcerWoundType[]>> {
    return await firstValueFrom(
      this.apiService.get<UlcerWoundType[]>(
        `${environment.apiLocations.patient}/ulcerwoundtype`,
      ),
    );
  }
}
